import * as Sentry from '@sentry/vue';
import { ofetch } from 'ofetch';
import { joinURL } from 'ufo';

import { onCheckRefresh } from './interceptors';

import { readRawCookies } from '@/composables/useCookie';
import { COOKIE_KEY } from '@/constant';

import type { FetchOptions } from 'ofetch';

type Method =
  | 'GET'
  | 'DELETE'
  | 'HEAD'
  | 'OPTIONS'
  | 'POST'
  | 'PUT'
  | 'PATCH'
  | 'PURGE'
  | 'LINK'
  | 'UNLINK';

interface RequestOptions extends Omit<FetchOptions, 'body'> {
  /**
   * 決定要使用哪個路由 `http://VITE_APP_API_URL/${route}`
   * @default 'api'
   */
  baseURL?: 'api' | 'common';

  method?: Method;
  data?: FetchOptions['body'];
}

const API_URL = import.meta.env.VITE_APP_API_URL;

// TODO: 加上詳細的成功判斷
export async function request<T>(
  url: string,
  options: RequestOptions = {}
): Promise<T> {
  const { data, baseURL = 'api', ...rest } = options;

  const token = readRawCookies()?.[COOKIE_KEY.TOKEN];
  const accessToken = readRawCookies()?.[COOKIE_KEY.ACCESS_TOKEN];

  const _options: FetchOptions = {
    ...rest,
    baseURL: joinURL(API_URL, baseURL),
    body: data,
    onRequest: onCheckRefresh,
    headers: token
      ? {
          Authorization: `Bearer ${accessToken}`,
        }
      : undefined,
  };

  return await ofetch(url, _options)
    .then(result => {
      if (options.responseType == null || options.responseType === 'json') {
        if (result.status.code !== '1') throw `[API ERROR] ${url}`;
        return result.data;
      }

      return result;
    })
    .catch(async error => {
      Sentry.captureException(error, {
        extra: {
          url,
          options,
          data: error.data,
        },
      });
      if (error.data instanceof Blob) {
        const text = await error.response._data.text();
        const errorJson = JSON.parse(text);
        throw errorJson;
      } else throw error.data;
    });
}
